"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.176.2
//   protoc               v4.23.4
// source: stats-proto/proto/stats.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resolution = exports.protobufPackage = void 0;
/* eslint-disable */
exports.protobufPackage = "blockscout.stats.v1";
var Resolution;
(function (Resolution) {
    Resolution["RESOLUTION_UNSPECIFIED"] = "RESOLUTION_UNSPECIFIED";
    Resolution["DAY"] = "DAY";
    Resolution["WEEK"] = "WEEK";
    Resolution["MONTH"] = "MONTH";
    Resolution["YEAR"] = "YEAR";
    Resolution["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Resolution || (exports.Resolution = Resolution = {}));
